export const getUserSettingsDataSql = () => "api/Personalization/User";
export const postUserSettingsDataSql = () => "api/UserSettings/Personalization";
export const postUserAcceptGuideSql = () => "api/Users/AcceptGuide";
